<template>
    <div class="flex flex-col items-center lg:items-start lg:flex-row flex-wrap justify-between">
        <cLogo :footer="footer" />

        <c-category
            v-for="(category, index) in categoriesList"
            :key="index"
            :footer="footer"
            :category="category"
            class="mb-4 lg:mb-0 text-center"
        />

        <c-newsletter-mini
            class="lg:items-end"
            v-if="footer.newsletter && footer.newsletterLayout == 'mini'"
            :footer="footer"
        />
        <cSocials v-else :footer="footer" />
    </div>
</template>

<script>
import cSocials from "../components/cSocials.vue";
import cLogo from "../components/cLogo.vue";
import CNewsletterMini from "../components/cNewsletterMini.vue";
import cCategory from "../components/cCategory.vue";

export default {
    name: "vNavCenter",
    components: {
        cSocials,
        cLogo,
        CNewsletterMini,
        cCategory,
    },
    props: {
        footer: Object,
    },
    computed: {
        categoriesList() {
            return this.footer.categories.filter((c) => !c._deleted);
        },
    },
};
</script>
